export default __webpack_public_path__ + "static/media/Dhruvil.47c85e82.png";